import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import SlickCarousel from 'react-slick';
import debounce from 'lodash/debounce';

var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);

  var _super = _createSuper(Carousel);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);

    _this.next = function () {
      _this.slick.slickNext();
    };

    _this.prev = function () {
      _this.slick.slickPrev();
    };

    _this.onWindowResized = function () {
      var autoplay = _this.props.autoplay;

      if (autoplay && _this.slick && _this.slick.innerSlider && _this.slick.innerSlider.autoPlay) {
        _this.slick.innerSlider.autoPlay();
      }
    };

    _this.renderArrow = function (dir, arrowDir) {
      var _this$props = _this.props,
          dotPosition = _this$props.dotPosition,
          showArrows = _this$props.showArrows,
          arrowStyle = _this$props.arrowStyle;
      var vertical = dotPosition === 'left' || dotPosition === 'right';
      if (vertical || !showArrows) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-carousel-arrow', "roo-carousel-".concat(dir)),
        onClick: dir === 'prev' ? _this.prev : _this.next
      }, /*#__PURE__*/React.createElement(Icon, {
        style: arrowStyle,
        name: "chevron-".concat(arrowDir),
        size: 18
      }));
    };

    _this.renderCarousel = function () {
      var prefix = 'roo-carousel';
      var dotsClass = 'slick-dots';
      var _this$props2 = _this.props,
          dotPosition = _this$props2.dotPosition,
          customPaging = _this$props2.customPaging,
          className = _this$props2.className,
          style = _this$props2.style;
      var vertical = dotPosition === 'left' || dotPosition === 'right';

      if (!customPaging) {
        dotsClass = "".concat(dotsClass, " ").concat(dotsClass, "-").concat(dotPosition || 'bottom');
      } else {
        dotsClass = "".concat(dotsClass, " slick-thumb");
      }

      var myProps = _Object$assign(_Object$assign({}, _this.props), {
        vertical: vertical,
        dotsClass: dotsClass
      });

      return /*#__PURE__*/React.createElement("div", {
        className: classNames(prefix, _defineProperty({}, "".concat(prefix, "-vertical"), !!vertical), className),
        style: style
      }, _this.renderArrow('prev', 'left'), /*#__PURE__*/React.createElement(SlickCarousel, _Object$assign({
        ref: function ref(slick) {
          _this.slick = slick;
        }
      }, myProps), React.Children.map(myProps.children, function (item) {
        return /*#__PURE__*/React.createElement("div", null, item);
      })), _this.renderArrow('next', 'right'));
    };

    _this.onWindowResized = debounce(_this.onWindowResized, 500, {
      leading: false
    });
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoplay = this.props.autoplay;

      if (autoplay) {
        window.addEventListener('resize', this.onWindowResized);
      }

      this.innerSlider = this.slick && this.slick.innerSlider;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (React.Children.count(this.props.children) !== React.Children.count(prevProps.children)) {
        this.goTo(this.props.initialSlide || 0, false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var autoplay = this.props.autoplay;

      if (autoplay) {
        window.removeEventListener('resize', this.onWindowResized);
        this.onWindowResized.cancel();
      }
    }
  }, {
    key: "goTo",
    value: function goTo(slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.slick.slickGoTo(slide, dontAnimate);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.renderCarousel());
    }
  }]);

  return Carousel;
}(React.Component);

Carousel.propTypes = {
  dots: PropTypes.bool,
  dotsPosition: PropTypes.string,
  arrows: PropTypes.bool,
  draggable: PropTypes.bool,
  showArrows: PropTypes.bool
};
Carousel.defaultProps = {
  dots: true,
  dotsPosition: 'bottom',
  arrows: false,
  draggable: false,
  showArrows: true
};
export default Carousel;